import { useState } from "react";
import MenuItem from "@mui/material/MenuItem";
import classes from "./CreateQuestions.module.css";
import { Box, Typography, Popover } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { gradeOptionsTools} from "../../constants";
import { setFormData } from '../../slices/form';

export default function GradeSelector({grade, selectStoreData}) {
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const storeData = useSelector(selectStoreData);
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleGradeSelection = (value) => {
    dispatch(setFormData({ grade: value }));
    localStorage.setItem("grade", value);
    handleClose();
  };

  return (
    <Box style={{paddingTop: '10px'}}>
      <Box onClick={handleOpen} className={classes["selectTitleLanguage"]}>
        <Typography className={classes["selectLanguageText"]}>
          Grade:{" "}
        </Typography>
        <Box className={classes["languageSelectBox"]}>
          <Typography className={classes["languageSelectText"]}>
            {grade || "None selected"}
          </Typography>
          <Box style={{ display: "flex", justifyContent: "space-between" }}>
            <svg
              height="20"
              width="20"
              viewBox="0 0 20 20"
              aria-hidden="true"
              focusable="false"
              className={anchorEl ? classes.svgRotate : ""}
            >
              <path d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path>
            </svg>
          </Box>
        </Box>
      </Box>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        sx={{
          width: "355px",
          borderRadius: "10px",
        }}
      >
        <div style={{ padding: "10px" }}>
          {gradeOptionsTools.map((option, index) => (
            <MenuItem
              key={index}
              onClick={() => {
                const selectedValue = option.name ? option.value : option;
                handleGradeSelection(selectedValue);
              }}
            >
              {option.name ? option.name : option}
            </MenuItem>
          ))}
        </div>
      </Popover>
    </Box>
  );
}
